import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TypeSignIcon } from '../../../../images/icons/WrapSvg';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.form.actions';

import Task from './Task';
import SignDialog from '../../../dialogs/Sign';

// eslint-disable-next-line
import style from './_styles.css';

class Index extends React.Component {
    state = {
        valor: '',
        comment: '',
        point: 0,
        correction: 0,
        message: undefined,
        intervalId: undefined,
        desactivado: false,
    };

    static getDerivedStateFromProps(props, state) {
        const { data, parentDeactivated } = props;
        if (data !== state.data || parentDeactivated !== state.parentDeactivated) {
            state.valor = data.valor;
            state.desactivado = data.desactivado;
            state.data = data;
            state.parentDeactivated = parentDeactivated;
            return state;
        }
        return null;
    }

    handleChange = (valor) => {
        const { data } = this.state;
        this.props.setValue(data.codigo, valor, '', false, {});
        this.setState({ valor: valor });
    };

    handleClickOpen = (event) => {
        this.setState({ open: true });
    };

    handleClose = (action) => {
        if (action === 'delete') {
            let valor = undefined;
            const { data } = this.state;
            this.props.setValue(data.codigo, valor, '', false, {});
            this.setState({ valor: valor, open: false });
        } else if (action === 'cancel') {
            this.setState({ open: false });
        } else {
            const { data } = this.state;
            this.props.setValue(data.codigo, action, '', false, {});
            this.setState({ valor: action, open: false });
        }
    };

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked, valor: '' });
    };

    getComponent = (valor, open, disabled) => {
        return (
            <div>
                <img
                    src={valor}
                    alt={''}
                    className={'preview_sign bg_white'}
                    onClick={() => this.handleClickOpen()}
                />
                {open && !disabled && (
                    <SignDialog
                        open={open}
                        src={valor}
                        handleClose={this.handleClose}
                        handleChange={this.handleChange}
                    />
                )}
            </div>
        );
    };

    render() {
        const { data, last, editable } = this.props;
        const { valor, open, desactivado, parentDeactivated } = this.state;

        return (
            <Task
                key={data.codigo}
                data={data}
                editable={editable}
                desactivado={desactivado}
                value={valor ? valor : undefined}
                icon={<TypeSignIcon color="primary" />}
                text="type_label_signature"
                last={last}
                component={this.getComponent(
                    valor,
                    open,
                    !editable || data.disabled || desactivado || parentDeactivated,
                )}
                parentDeactivated={parentDeactivated}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

Index.propTypes = {
    instance_changes: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance_changes: state.instance_changes,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};
Index = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Index);

export default Index;



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/Sign.js